import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Add, Search } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import { useFormikContext } from "formik";
import { useStore } from "app/stores";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { ISUSING } from "app/common/LocalConst";
const SearchRegisterTreatmentPlan = () => {
  const { setFieldValue, values } = useFormikContext();
  const { handleChangeFormSearchTreatmentPlan } =
    useStore().patientManagementStore.registerTreatmentPlanStore;

  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            name="keyword"
            placeholder={"Nhập tên/Mã dịch vụ"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsMultiDatePicker
            label="Ngày đăng ký từ ngày - đến ngày"
            name="fromDate"
            range
            rangeHover
            fromField="fromDate"
            toField="toDate"
            // format={"DD/MM/YYYY"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsSelectInput
            options={ISUSING}
            label={"Trạng thái sử dụng"}
            name="isUse"
            // onChange={handleChangeSearch}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="flex flex-end gap-2">
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
          {/* <CommonButton
            className="btn-add"
            onClick={() => {
              handleOpenCreateOrEditPopup();
            }}
          >
            <Add />
          </CommonButton> */}
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(SearchRegisterTreatmentPlan));
